import './js/API';
import './js/authentication/form';

// import './js/handlers/bookCategory';
// import './js/handlers/markup-category-list';
import './js/test/swiper-supportUkraine';
import './js/switcher-theme-fn';
import './js/test/shoppingListCounter'

import './js/test/book-category';
import './js/test/fetch-category';
import './js/test/fetch-search-result';
import './js/test/markup-category-list';
import './js/test/markup-top-books';

import './js/test/pop-up';



import './js/test/mobileMenu';

import './js/scroll';

import './js/header/index';

import './js/test/change-current-category';